import { cloneDeep } from 'lodash-es';
import { ElectronApi } from '../electron.api';
import { testAccess } from '@/utils/fs/fs-extra.utils';

export class WatchfaceEditorConfig {
  private editorConfigPath: string;

  constructor(editorConfigPath: string) {
    this.editorConfigPath = editorConfigPath;
  }

  async getEditorData() {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;

    const configPath = this.editorConfigPath;
    let data: StoreEditorConfig | undefined;
    // 读取 editor.config.json
    try {
      const res = await fs.promises
        .readFile(configPath, 'utf8')
        .then((r) => {
          return r
            .replace('timeHour_timeMinute', 'time')
            .replace('batteryAccuracy', 'sourceProgressAccuracy');
        })
        .then((r) => JSON.parse(r));

      if (Array.isArray(res)) {
        data = {
          themes: res
        } as StoreEditorConfig;
      } else {
        data = res as StoreEditorConfig;
      }
    } catch (e) {
      // create if not exists
      data = { themes: [] };
      if (!(await testAccess(configPath))) {
        await fs.promises.writeFile(
          configPath,
          JSON.stringify(data, undefined, 2)
        );
      }
    }
    return data;
  }
  async writeEditorData(data: Partial<StoreEditorConfig>) {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;

    const {
      themes,
      aodDisplayMode,
      i18n,
      formats,
      dataSource,
      isSlotFollowing,
      introData
    } = data;
    const configData = ((await this.getEditorData()) ??
      {}) as StoreEditorConfig;

    if (themes) configData['themes'] = themes;
    if (aodDisplayMode) configData['aodDisplayMode'] = aodDisplayMode;
    if (i18n) configData['i18n'] = i18n;
    if (formats) configData['formats'] = formats;
    if (dataSource) configData['dataSource'] = dataSource;
    if (isSlotFollowing !== undefined)
      configData['isSlotFollowing'] = isSlotFollowing;
    if (introData) configData['introData'] = introData;

    // 更新版本信息

    const to = this.editorConfigPath;
    await fs.promises.writeFile(to, JSON.stringify(configData, undefined, 2));
  }
}
